import { DialogContentText } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import React, { useEffect, useState } from 'react';
import colors from '../../styles/settings/colors';
import fontSize from '../../styles/settings/fontSize';
import * as S from './styles';

const headerText = {
  confirmacao: 'Confirmação',
  substituicao: 'Substituição',
  cancelamento: 'Cancelamento',
};

const messageType = {
  confirmacao: 'Confirma o envio da proposta?',
  aprovacao: 'Aprovar nova proposta com Abatimentos/Descontos?',
  confirmacaoFechamento: 'Confirma o envio do fechamento?',
  confirmaEmail: 'Confirma o envio dos emails de interesse?',
  confirmacaoSendEmail: 'Confirma o envio dos emails para a rede?',
  confirmacaoSendEmailTerceiro: 'Confirma o envio dos emails para o terceiro?',
  substituicao: 'Confirma a substituição da proposta?',
  cancelamento: 'Confirma o cancelamento da proposta?',
  confirmacaoPonto: 'Deseja mesmo registrar esse ponto?',
  confirmationRede: 'Confirma destino de pagamento',
  removerRede: 'Deseja mesmo remover esta rede?',
  aplicarAbatimentosDescontos: 'Aplicar Abatimentos/Descontos?'
};

const buttonTextType = {
  confirmacao: 'Sim',
  substituicao: 'Sim',
  cancelamento: 'Sim',
  confirmationRede: 'REDE',
  removerRede: 'Sim'
};

const defaultValues = {
  show: false,
  message: null,
  callback: null,
  callbackOptional: null,
  labelOptional: null,
  optionalButton: false,
  labelClose: null,
  closeBtnLastLayout: false,
  rede: null,
  plataforma: null,
  htmlText: null,
  anchorTitle: null,
  onlyOneButton: false
};

export function ConfirmationBox({ data, setConfirmationBox }) {
  const [open, setOpen] = useState(false);
  // Desabilita botão se for removeContact OU se tiver htmlText com textarea de motivo
  const hasReasonTextarea = data?.htmlText?.includes('id="removalReason"');
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(
    (data?.type === 'removeContact' || hasReasonTextarea) ? true : (data?.confirmButtonDisabled || false)
  );

  const handleClose = (event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }
    setOpen(false);
    setConfirmationBox(defaultValues);
  };

  const handleConfirm = () => {
    const shouldClose = data.callback();
    if (shouldClose !== false) {
      setOpen(false);
      setConfirmationBox(defaultValues);
    }
  };

  // Função para transformar texto em uppercase no campo de motivo
  useEffect(() => {
    if (!data?.show) return;
    
    let timeoutId = null;
    
    // Aguarda um pouco para garantir que o DOM foi renderizado
    timeoutId = setTimeout(() => {
      const textareaElement = document.getElementById('removalReason');
      if (textareaElement && !textareaElement.hasAttribute('data-uppercase-listener')) {
        textareaElement.setAttribute('data-uppercase-listener', 'true');
        const handleInput = (e) => {
          const cursorPosition = e.target.selectionStart;
          e.target.value = e.target.value.toUpperCase();
          e.target.setSelectionRange(cursorPosition, cursorPosition);
        };
        // Armazena o handler no elemento para poder removê-lo depois
        textareaElement._uppercaseHandler = handleInput;
        textareaElement.addEventListener('input', handleInput);
      }
    }, 100);
    
    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      const textareaElement = document.getElementById('removalReason');
      if (textareaElement && textareaElement._uppercaseHandler) {
        textareaElement.removeEventListener('input', textareaElement._uppercaseHandler);
        delete textareaElement._uppercaseHandler;
        textareaElement.removeAttribute('data-uppercase-listener');
      }
    };
  }, [data?.show, data?.htmlText]);

  // Função para verificar o campo de motivo
  useEffect(() => {
    if (!data?.show) return;
    
    // Verifica se tem textarea de motivo (usado em removeContact e relatórios dinâmicos)
    const hasReasonField = document.getElementById('removalReason') !== null;
    
    // Verifica se é um modal de confirmação (não deve ter validação de motivo)
    const isConfirmationModal = data?.htmlText && 
      (data.htmlText.includes('Confirma a Inclusão') || 
       data.htmlText.includes('Confirmação de ação') ||
       data.htmlText.includes('Confirma a Exclusão'));
    
    if ((data?.type === 'removeContact' || hasReasonField) && !isConfirmationModal) {
      // Inicia desabilitado se tem campo de motivo E não é modal de confirmação
      setIsConfirmDisabled(true);
      
      const checkInput = setInterval(() => {
        const inputElement = document.getElementById('removalReason');
        if (inputElement) {
          const isValid = inputElement.value.trim().length >= 20;
          setIsConfirmDisabled(!isValid);
        }
      }, 100);
      return () => clearInterval(checkInput);
    } else {
      // Se não tem campo de motivo OU é modal de confirmação, habilita o botão
      setIsConfirmDisabled(false);
    }
  }, [data?.show, data?.htmlText]);

  const handleOptional = () => {
    setOpen(false);
    setConfirmationBox(defaultValues);
    data.callbackOptional();
  };

  useEffect(() => {
    if (data.show) {
      setOpen(true);
    }
  }, []);

  return (
		<S.DialogModal
			open={open}
			onClose={handleClose}
			disableEscapeKeyDown
			className="dialog-parent"
			widthContainer={data?.mensagemBoxLargura}
			htmlText={data?.htmlText}
		>
			<S.DialogContainer
				borderColor={data?.tituloCorDeFundo}
			>
				<div className="margin-container">
					<S.Title>
						{data.anchorTitle ? (
							<>
								Informações da rede
								<br />
								{data.anchorTitle}
							</>
						) : data.titulo ? (
							data.titulo
						) : (
							"Confirmação de ação"
						)}
					</S.Title>
					

					{data.htmlText ? (
						<div style={{ fontSize: fontSize.button, padding: "10px" }}>
							<S.DialogHtmlDiv
								dangerouslySetInnerHTML={{ __html: data.htmlText }}
							>
								
							</S.DialogHtmlDiv>
						</div>
					) : (
						<div
							style={{
								fontSize: fontSize.button,
								padding: "10px",
								textAlign: "center",
							}}
						>
							
							{data.message}
							{data.type === "removerRede" && data.rede
								? `Deseja mesmo remover ${data.rede}?`
								: data.type === "inactivePlatform" && data.plataforma
								? `Confirma inativar a Plataforma ${data.plataforma}?`
								: messageType[data.type]}
							<br />
							{data.type === "inactivePlatform" && data.plataforma
								? `Todas as redes e analistas serão removidos.`
								: ""}
						</div>
					)}

					{/* <S.BodyText>
            <p>teste1</p>
            <DialogContentText style={{ fontSize: fontSize.button }}>


              {data.type === 'removerRede' && data.rede ? `Deseja mesmo remover ${data.rede}?`
                : data.type === 'inactivePlatform' && data.plataforma ? `Confirma inativar a Plataforma ${data.plataforma}? Todas as redes e analistas serão removidos.`
                  : messageType[data.type]}
            </DialogContentText>

          </S.BodyText> */}

					<S.DialogActionsMessage>
						{!data.closeBtnLastLayout && (
							<Button
								onClick={handleClose}
								style={
									data.htmlText
										? {
												backgroundColor: "rgb(35, 45, 100)",
												fontWeight: "400",
												color: "#fff",
										  }
										: { backgroundColor: "#e0e0e0", fontWeight: "400" }
								}
							>
								{data.labelClose ? data.labelClose : "Não"}
							</Button>
						)}
						{data?.optionalButton && (
							<Button
								style={{
									color: colors.white,
									backgroundColor: colors.sanMarino,
									fontWeight: "400",
								}}
								autoFocus
								focusVisible
								onClick={handleOptional}
							>
								{buttonTextType[data.type]}
							</Button>
						)}
						{!data.onlyOneButton && (
							<Button
								id={data?.confirmButtonId || 'confirmButton'}
								disabled={isConfirmDisabled}
								style={{
									color: colors.white,
									backgroundColor: isConfirmDisabled ? '#ccc' : colors.sanMarino,
									fontWeight: "400",
									cursor: isConfirmDisabled ? 'not-allowed' : 'pointer',
								}}
								autoFocus
								focusVisible
								onClick={handleConfirm}
							>
								{data.labelOptional
									? data.labelOptional
									: buttonTextType[data.type] || "Sim"}
							</Button>
						)}
						{data.closeBtnLastLayout && (
							<Button
								onClick={handleClose}
								style={
									data.htmlText
										? {
												backgroundColor: "rgb(35, 45, 100)",
												fontWeight: "400",
												color: "#fff",
										  }
										: { backgroundColor: "#e0e0e0", fontWeight: "400" }
								}
							>
								{data.labelClose ? data.labelClose : "Não"}
							</Button>
						)}
					</S.DialogActionsMessage>
				</div>
			</S.DialogContainer>
		</S.DialogModal>
	);
}
